
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0ff6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0ff6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lUqp4", function(module, exports) {

$parcel$export(module.exports, "trackGearEvent", () => $ff334f1dea0b03d9$export$e8e6f820c6bc0ced);
$parcel$export(module.exports, "installGearNavigationTracking", () => $ff334f1dea0b03d9$export$1e00a1666045f2fb);
// The existing GTM-K2JH98K5 container loads this Google tag. Do not load or
// configure another tag here. Verified against the public container 2026-10-03.
const $ff334f1dea0b03d9$export$621d64bf087f295a = 'G-K7VZ640RSR';
function $ff334f1dea0b03d9$export$e8e6f820c6bc0ced(name, parameters = {}) {
    const send = ()=>{
        try {
            window.dataLayer = window.dataLayer || [];
            // Google tag commands work even when GTM does not expose window.gtag.
            // Arguments objects are the documented gtag queue format; no manual
            // page_view and no duplicate object-event transport.
            function queue() {
                window.dataLayer.push(arguments);
            }
            queue('event', name, {
                ...parameters,
                send_to: $ff334f1dea0b03d9$export$621d64bf087f295a
            });
        } catch  {
        // Blocking analytics must never break navigation or category controls.
        }
    };
    // The GTM Google tag must configure its destination before receiving event
    // commands. Async tag scripts participate in the document load lifecycle.
    // Waiting for load avoids a race on fast cached HTML / slow tag downloads.
    if (document.readyState === 'complete') send();
    else try {
        window.addEventListener('load', send, {
            once: true
        });
    } catch  {}
}
const $ff334f1dea0b03d9$var$NAVIGATION_KEY = 'sfpdcalls:gear-navigation';
function $ff334f1dea0b03d9$var$navigationParameters(link) {
    return {
        direction: link.dataset.gearNavigation === 'gear' ? 'to_prod' : 'to_map',
        page_path: link.dataset.gearNavigation === 'gear' ? '/' : '/prod',
        destination_path: link.dataset.gearNavigation === 'gear' ? '/prod' : '/'
    };
}
function $ff334f1dea0b03d9$var$recordNavigation(event, link) {
    const parameters = $ff334f1dea0b03d9$var$navigationParameters(link);
    // A same-tab click can unload before GTM finishes loading. Hand off its
    // small, fixed record to the destination instead of delaying navigation.
    const sameTab = event.type === 'click' && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && !event.defaultPrevented;
    if (sameTab) try {
        window.sessionStorage.setItem($ff334f1dea0b03d9$var$NAVIGATION_KEY, JSON.stringify({
            ...parameters,
            created_at: Date.now()
        }));
        return;
    } catch  {}
    $ff334f1dea0b03d9$export$e8e6f820c6bc0ced('prod_internal_navigation', {
        ...parameters,
        navigation_stage: 'activation'
    });
}
function $ff334f1dea0b03d9$var$consumeNavigation() {
    try {
        const record = JSON.parse(window.sessionStorage.getItem($ff334f1dea0b03d9$var$NAVIGATION_KEY));
        window.sessionStorage.removeItem($ff334f1dea0b03d9$var$NAVIGATION_KEY);
        if (!record) return;
        const validDirection = record.direction === 'to_prod' || record.direction === 'to_map';
        const destination = record.direction === 'to_prod' ? '/prod' : '/';
        const currentPath = window.location.pathname.replace(/\/$/, '') || '/';
        const age = Date.now() - record.created_at;
        if (!validDirection || record.destination_path !== destination || currentPath !== destination || !Number.isFinite(age) || age < 0 || age > 300000) return;
        $ff334f1dea0b03d9$export$e8e6f820c6bc0ced('prod_internal_navigation', {
            direction: record.direction,
            page_path: record.direction === 'to_prod' ? '/' : '/prod',
            destination_path: destination,
            navigation_stage: 'arrival'
        });
    } catch  {}
}
function $ff334f1dea0b03d9$export$1e00a1666045f2fb(root = document) {
    $ff334f1dea0b03d9$var$consumeNavigation();
    const handler = (event)=>{
        if (event.type === 'auxclick' && event.button !== 1) return;
        const link = event.target.closest?.('a[data-gear-navigation]');
        if (link) $ff334f1dea0b03d9$var$recordNavigation(event, link);
    };
    root.addEventListener('click', handler);
    root.addEventListener('auxclick', handler);
}

});


var $lUqp4 = parcelRequire("lUqp4");
const $3e35473738ec2b18$var$NAVIGATION_KEY = 'sfpdcalls:editorial-navigation';
const $3e35473738ec2b18$var$allowedDestination = (path)=>path === '/' || path === '/prod' || /^\/blog(?:\/[a-z0-9-]+)?$/.test(path);
function $3e35473738ec2b18$var$consumeNavigation() {
    try {
        const record = JSON.parse(window.sessionStorage.getItem($3e35473738ec2b18$var$NAVIGATION_KEY));
        window.sessionStorage.removeItem($3e35473738ec2b18$var$NAVIGATION_KEY);
        if (!record) return;
        const age = Date.now() - record.created_at;
        const currentPath = window.location.pathname.replace(/\/$/, '') || '/';
        if (!$3e35473738ec2b18$var$allowedDestination(record.destination_path) || currentPath !== record.destination_path || !Number.isFinite(age) || age < 0 || age > 300000) return;
        (0, $lUqp4.trackGearEvent)('editorial_navigation', {
            ...record.parameters,
            navigation_stage: 'arrival'
        });
    } catch  {}
}
function $3e35473738ec2b18$var$recordNavigation(event, link, info) {
    const destination = new URL(link.href).pathname.replace(/\/$/, '') || '/';
    if (!$3e35473738ec2b18$var$allowedDestination(destination)) return;
    const parameters = {
        ...info,
        page_path: window.location.pathname,
        destination_path: destination
    };
    const sameTab = event.type === 'click' && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && !event.defaultPrevented;
    if (sameTab) try {
        window.sessionStorage.setItem($3e35473738ec2b18$var$NAVIGATION_KEY, JSON.stringify({
            destination_path: destination,
            parameters: parameters,
            created_at: Date.now()
        }));
        return;
    } catch  {}
    (0, $lUqp4.trackGearEvent)('editorial_navigation', {
        ...parameters,
        navigation_stage: 'activation'
    });
}
function $3e35473738ec2b18$export$3c8e6dbd2227432b(root = document) {
    $3e35473738ec2b18$var$consumeNavigation();
    const article = root.querySelector('article[data-article-slug]');
    const info = article ? {
        article_slug: article.dataset.articleSlug,
        article_title: article.dataset.articleTitle,
        article_category: article.dataset.articleCategory
    } : {};
    const canonical = root.querySelector('link[rel="canonical"]')?.href;
    if (article) (0, $lUqp4.trackGearEvent)('article_view', info);
    const copy = root.querySelector('[data-share="copy"]');
    if (copy && navigator.clipboard?.writeText) copy.hidden = false;
    const native = root.querySelector('[data-share="native"]');
    if (native && navigator.share) native.hidden = false;
    const status = root.querySelector('.share-status');
    const reportShare = (method)=>(0, $lUqp4.trackGearEvent)('article_share', {
            article_slug: info.article_slug,
            share_method: method
        });
    const frame = root.querySelector('[data-video-id]');
    const player = frame?.querySelector('iframe');
    let playRecorded = false;
    const postToPlayer = (message)=>{
        try {
            player?.contentWindow?.postMessage(JSON.stringify(message), 'https://www.youtube-nocookie.com');
        } catch  {}
    };
    const listenForState = ()=>{
        postToPlayer({
            event: 'listening',
            id: 'sfpdcalls-video'
        });
        postToPlayer({
            event: 'command',
            func: 'addEventListener',
            args: [
                'onStateChange'
            ],
            id: 'sfpdcalls-video'
        });
    };
    if (player) {
        // Keep the native YouTube player visible. Playback starts muted only when
        // the video enters the viewport; its own controls always remain available.
        const url = new URL(player.src);
        url.searchParams.set('origin', window.location.origin);
        player.addEventListener('load', listenForState);
        player.src = url.href;
        (0, $lUqp4.trackGearEvent)('video_load', {
            article_slug: info.article_slug,
            video_provider: 'youtube',
            video_id: frame.dataset.videoId
        });
        if (typeof IntersectionObserver === 'function') {
            const observer = new IntersectionObserver((entries)=>{
                if (!entries.some((entry)=>entry.isIntersecting && entry.intersectionRatio >= 0.25)) return;
                observer.disconnect();
                if (playRecorded) return;
                const autoplayURL = new URL(player.src);
                autoplayURL.searchParams.set('autoplay', '1');
                autoplayURL.searchParams.set('mute', '1');
                player.src = autoplayURL.href;
            }, {
                threshold: 0.25
            });
            observer.observe(frame);
        }
    }
    // Listen to the one player's messages; do not download the YouTube IFrame API.
    // Loading the visible iframe is never falsely reported as actual playback.
    window.addEventListener('message', (event)=>{
        if (!player || event.source !== player.contentWindow || event.origin !== 'https://www.youtube-nocookie.com') return;
        let data;
        try {
            data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
        } catch  {
            return;
        }
        if (!data || typeof data !== 'object') return;
        if (data.event === 'onReady') listenForState();
        if (!playRecorded && (data.event === 'onStateChange' && data.info === 1 || data.event === 'infoDelivery' && data.info?.playerState === 1)) {
            playRecorded = true;
            (0, $lUqp4.trackGearEvent)('video_play', {
                article_slug: info.article_slug,
                video_provider: 'youtube',
                video_id: frame.dataset.videoId
            });
        }
    });
    const navigation = (event)=>{
        if (event.type === 'auxclick' && event.button !== 1) return;
        const link = event.target.closest?.('a[data-editorial-navigation]');
        if (link) $3e35473738ec2b18$var$recordNavigation(event, link, info);
    };
    root.addEventListener('auxclick', navigation);
    root.addEventListener('click', async (event)=>{
        navigation(event);
        const share = event.target.closest?.('[data-share]');
        if (!share || !canonical) return;
        const method = share.dataset.share;
        if (method === 'copy') try {
            await navigator.clipboard.writeText(canonical);
            status.textContent = 'Link copied.';
            reportShare('copy');
        } catch  {
            status.textContent = `Copy this link: ${canonical}`;
        }
        else if (method === 'native') try {
            await navigator.share({
                title: info.article_title,
                url: canonical
            });
            reportShare('native');
        } catch (error) {
            if (error.name !== 'AbortError') status.textContent = `Share this link: ${canonical}`;
        }
        else reportShare(method);
    });
}
$3e35473738ec2b18$export$3c8e6dbd2227432b();


//# sourceMappingURL=repo.7f538b34.js.map
